export default __webpack_public_path__ + "static/media/homelandingbg.712170c7.png";